import React from "react";
import ReactDOM from "react-dom";
// import "core-js/stable";
import "react-app-polyfill/ie11";
import "react-app-polyfill/stable";
import "./styles/index.css";
import App from "./App";

ReactDOM.render(
  <React.StrictMode>
    <App/>
  </React.StrictMode>,
  document.getElementById("root")
);
